/* folder_open.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.7 20.5" preserveAspectRatio="none">
        <path class="foreground-gl" d="M16.62,8,8.33,8A.5.5,0,0,1,8,7.85l-.16-.31a.81.81,0,0,0-.69-.35H2.49c-.28,0-.44.16-.34.35l.14.3c0,.09-.06.16-.29.16H1C.42,8,.1,8.34.3,8.74L4.39,17a1.69,1.69,0,0,0,1.42.72l15.61,0c.59,0,.91-.33.71-.73L18,8.69A1.45,1.45,0,0,0,16.62,8Z"/>
        <path class="foreground-gl" d="M21.41,2.67H5.85A1.07,1.07,0,0,0,4.79,3.73V5.3H7a.72.72,0,0,1,.69.32L8,6a.52.52,0,0,0,.38.16h9.1c1.11,0,1.51.35,2.1,1.45l2.95,5.91V3.73A1.07,1.07,0,0,0,21.41,2.67Z"/>
        </svg>
    `
};
